"use client";

import { Calculator, GraduationCap, Send, type LucideIcon } from "lucide-react";
import { ratgeberTheme, type RatgeberColor, type RatgeberIcon } from "@/lib/ratgeber";
import { cn } from "@/lib/utils";

const ICONS: Record<RatgeberIcon, LucideIcon> = {
  zulassung: GraduationCap,
  zulassungsrechner: Calculator,
  bewerbung: Send,
};

/** Kopf einer Mega-Menü-Spalte: farbige Icon-Kachel, Titel, Kurzbeschreibung. */
export default function MegaMenuHeader({
  icon,
  color,
  title,
  description,
}: {
  icon: RatgeberIcon;
  color: RatgeberColor;
  title: string;
  description: string;
}) {
  const Icon = ICONS[icon];
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <span
          className={cn(
            "w-10 h-10 shrink-0 rounded-lg flex items-center justify-center",
            ratgeberTheme[color].tile
          )}
        >
          <Icon size={18} aria-hidden="true" />
        </span>
        <h3 className="font-display font-bold text-[15px] text-ink">{title}</h3>
      </div>
      <p className="text-[13px] text-ink-faint leading-relaxed">{description}</p>
    </div>
  );
}
